import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from '../../../../../global/components/external-link-modal';
import { QuickActionItem } from '../../../../../global/models/quick-actions-model';

interface Props {
    item: QuickActionItem;
    reordering: boolean;
}
export function QuickActionItemDisplay(props: Props) {
    const { item, reordering } = props;

    if (!item) return null;

    if (reordering) {
        return <span className='btn-secondary quick-action-btn' data-testid='quick-action-search-result'>{item.actionName}</span>;
    }

    if (item?.externalLink) {
        return <ExternalLink className='btn-secondary quick-action-btn' linkUrl={item.externalLink} linkText={item.actionName} data-testid='quick-action-search-result'/>;
    }

    if (item?.internalLinkRoute) {
        return <Link className='btn-secondary quick-action-btn' to={item.internalLinkRoute} data-testid='quick-action-search-result'>{item.actionName}</Link>;
    }

    return null;
}